import objectUtils from '../utils/object-utils'

export default class Vehicle {
  constructor (options = {}) {
    this.model = 'Vehicle'
    this.id = objectUtils.get(options, 'id', null)
    this.vehicle_category = objectUtils.get(options, 'vehicle_category', null)

    this.make = objectUtils.get(options, 'make', null)
    this.vehicle_model = objectUtils.get(options, 'vehicle_model', null)
    this.color = objectUtils.get(options, 'color', null)
    this.year = objectUtils.get(options, 'year', null)
    this.notes = objectUtils.get(options, 'notes', null)
    this.nickname = objectUtils.get(options, 'nickname', null)
    this.license_plate = objectUtils.get(options, 'license_plate', null)
    this.vin_number = objectUtils.get(options, 'vin_number', null)

    this.last_odometer_reading = objectUtils.get(options, 'last_odometer_reading', null)
    this.vehicle_status = objectUtils.get(options, 'vehicle_status', null)

    this.created_by = objectUtils.get(options, 'created_by', null)
    this.created_at = objectUtils.get(options, 'created_at', null)
  }
}
